'use strict';

/**
 * @fileOverview Основной файл инициализации модулей
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import './_vendors/promise-polyfill';
import './_vendors/jquery';

import './_vendors/fm.revealator.jquery';
import './_vendors/responsive-tables';

import './_modules/lazy-load';
import horizontalScroll from './_modules/horizontal-scroll';
import wrapMedia from './_modules/wrap-media';
import validation from './_modules/validation';
import {mfpAjax, mfpGallery, mfpInline} from './_modules/magnific-popup';
import {mainSlider, firmsSlider, reviewsSlider} from './_modules/sliders';
import {fixedHeader, headerSearch, setPaddingTop, headerLang, loginToggle} from './_modules/header';
import {mobileMenu, filterMenu} from './_modules/mobile-menu';
import {spincrementNum} from './_modules/spincrement';
import {subMenuToggle} from './_modules/sidebar';
import {initSelect} from './_modules/select2';
import {initScrollbar} from './_modules/scrollbar';
import {initPassfield} from './_modules/pass-field';
import {initMap} from './_modules/map';
import {toggleContent} from './_modules/tables';
import {toggleDetails} from './_modules/promo';
import {initCssMap} from './_modules/css-map';
import {loadItems} from './_modules/load-items';
import {displayWindow} from './_modules/open-window';
// import {previewer} from './_modules/_preview';
//
// if (IS_FTP || !IS_PRODUCTION) {
// 	previewer();
// }

// ----------------------------------------
// Public
// ----------------------------------------

window.jQuery(document).ready(($) => {
	horizontalScroll('.wysiwyg table');
	wrapMedia('.wysiwyg iframe, .wysiwyg video');
	validation('.js-form');
	mfpAjax('.js-mfp-ajax');
	mfpInline();
	mfpGallery();
	mainSlider();
	firmsSlider();
	headerSearch();
	mobileMenu();
	setPaddingTop();
	headerLang();
	spincrementNum();
	subMenuToggle('.sidebar__menu-link--child', '.sidebar__menu-item--child', '.sidebar__sub-menu');
	initScrollbar();
	initSelect();
	initPassfield();
	initMap();
	toggleContent();
	toggleDetails();
	loginToggle();
	initCssMap();
	loadItems();
	reviewsSlider();
	filterMenu();
	displayWindow();

	if (!$.trim($('.news-item__date-wrap').html()).length) {
		$('.news-item__date-wrap').remove();
	}
});

window.jQuery(window).on('scroll', function () {
	fixedHeader();
});

if (IS_PRODUCTION) {
	require('./_modules/wezom-log');
}



// WEBPACK FOOTER //
// ./src/js/entry.js